<template>
  <div id="main">
    <split-pane v-on:resize="resize" :min-percent='10' :default-percent='20' split="vertical">
      <template slot="paneL">
        <div id="treeDivs">
          <RolesTree :parentMsg="rolesTreeMsg" v-on:treeInfo="getTreeInfo"></RolesTree>
        </div>
      </template>
      <template slot="paneR">
        <div id="listTables">
          <div class="rightTopButton">
            <el-button
                    size="small"
                    @click="formAdd()"
                    type="primary">新增</el-button>
            <el-input
                    placeholder="请输入ID或名称搜索"
                    v-model="filterName"
                    class="input-with-select"
                    size="small"
                    style="width: 280px; float: right;"
                    clearable>
              <el-button slot="append" icon="el-icon-search" @click="inputSearch"></el-button>
            </el-input>
          </div>
          <div class="rightContent">
            <el-table
                    border
                    stripe
                    size="small"
                    ref="singleTable"
                    :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                    :data="tableData"
                    :highlight-current-row="true"
                    height="100%"
                    style="width: 100%">
              <el-table-column property="roleId" align="center" label="角色id" width="200"></el-table-column>
              <el-table-column property="roleName" label="名称"></el-table-column>
              <el-table-column property="isDefault" align="center" label="是否默认角色" width="120">
                <template slot-scope="scope">
                  {{getisDefault(scope.row.isDefault)}}
                </template>
              </el-table-column>
              <el-table-column property="orderNo" align="center" label="排序号" width="80"></el-table-column>
              <el-table-column align="center" width="220" label="操作">
                <template slot-scope="scope">
                  <el-button
                          size="mini"
                          type="primary"
                          icon="el-icon-user"
                          title="人员分配"
                          circle
                          plain
                          @click="disPerson(scope.$index, scope.row)"></el-button>
                  <el-button
                          size="mini"
                          type="primary"
                          icon="el-icon-document"
                          title="资源分配"
                          circle
                          plain
                          @click="disResource(scope.$index, scope.row)"></el-button>
                  <el-button
                          size="mini"
                          type="primary"
                          icon="el-icon-set-up"
                          title="单位数据权限分配"
                          circle
                          plain
                          @click="disUnit(scope.$index, scope.row)"></el-button>
                  <el-button
                          size="mini"
                          type="primary"
                          icon="el-icon-edit"
                          title="编辑"
                          circle
                          plain
                          @click="formEdit(scope.$index, scope.row)"></el-button>
                  <el-button
                          size="mini"
                          type="danger"
                          icon="el-icon-delete"
                          title="删除"
                          circle
                          plain
                          @click="formDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[15, 30, 50, 100]"
                    :page-size="rows"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
          </div>
        </div>
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
          <el-form :model="rolesForm" :rules="rules" ref="rolesForm">
            <el-form-item label="名称" :label-width="formLabelWidth" prop="roleName">
              <el-input v-model="rolesForm.roleName" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="排序号" :label-width="formLabelWidth" prop="orderNo">
              <el-input v-model="rolesForm.orderNo" placeholder="排序号"></el-input>
            </el-form-item>
            <el-form-item label="角色说明" :label-width="formLabelWidth" prop="memo">
              <el-input type="textarea" rows="3" v-model="rolesForm.memo" placeholder="角色说明"></el-input>
            </el-form-item>
<!--            <el-form-item label="编码" :label-width="formLabelWidth" prop="key">-->
<!--              <el-input v-model="rolesForm.key" placeholder="编码"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="是否默认角色" :label-width="formLabelWidth" style="text-align: left">-->
<!--              <el-switch v-model="rolesForm.switch"></el-switch>-->
<!--            </el-form-item>-->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="formSave('rolesForm')">确 定</el-button>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>

        <el-dialog class="roleDlg" title="角色人员分配" width="90%" :close-on-click-modal="false" :visible.sync="dialogPersonVisible">
          <div style="width: 25%; height: 380px;">
            <OrgTree :parentMsg="orgTreeMsg" v-on:treeInfo="getOrgTreeInfo"></OrgTree>
          </div>
            <el-transfer
            v-loading="roleDia_loading"
            element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
              style="width: 70%; text-align: left; padding-left: 28px; "
                    filterable
                    :filter-method="filterMethod"
                    filter-placeholder="请输入姓名"
                    v-model="selectedPersonData"
                    :props="{key: 'userId', label: 'lable'}"
                    :data="selectPersonData"
                    :titles="['待选人员', '已选人员']"
                    @change="choosePerson">
            </el-transfer>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogPersonVisible = false">确 定</el-button>
            <el-button @click="dialogPersonVisible = false">取 消</el-button>
          </div>
        </el-dialog>

        <div class="rDialogDiv">
          <!-- <el-dialog title="角色资源分配" id="resourceDialog" top="8vh" :close-on-click-modal="false" :visible.sync="dialogResourceVisible" >
            <div style="display: flex;height: 380px">
              <div style="width: 50%;">
                <div style="margin-left: 10px">待分配资源</div>
                <ResourcesTree :key="resourcesLeft" :parentMsg="resourceTreeMsg" v-on:getCheckedKeys="getResourceKeys"></ResourcesTree>
              </div>
              <div style="border-right: 1px solid #d9d9d9;margin: 0 20px"></div>
              <div style="width: 50%">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                  <div style="margin-left: 10px">已分配资源</div>
                  <div @click="open" style="margin-right: 10px;cursor: pointer;color: #409EFF">重新分配</div>
                </div>
                <ResourcesTree :key="resourcesRight" ref="rightTree" :filter="true" :parentMsg="resourceTreeMsg" v-on:getCheckedKeys="getResourceKeys"></ResourcesTree>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
             <el-button type="primary" @click="dialogResourceVisible = false">确 定</el-button>

              <el-button @click="dialogResourceVisible = false">取消</el-button>
            </div>
          </el-dialog> -->
          <el-dialog title="角色资源分配" id="resourceDialog" top="8vh" :close-on-click-modal="false" :visible.sync="dialogResourceVisible">
            <div style="height: 380px;">
              <ResourcesTree :parentMsg="resourceTreeMsg" v-on:getCheckedKeys="getResourceKeys"></ResourcesTree>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogResourceVisible = false">确 定</el-button>
              <el-button @click="dialogResourceVisible = false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
        <!-- 单位数据权限分配 -->
        <div class="rDialogDiv">
          <el-dialog title="单位数据权限分配" id="resourceDialog1" top="8vh" :close-on-click-modal="false" :visible.sync="dialogUnitVisible">
            <div style="display: flex;height: 380px">
              <div style="width: calc(50% - 20px);height: 100%">
                <div style="padding-bottom: 10px;">待选权限</div>
                <OrgTreeCheck :key="jurisdictionLeft" ref="templateTree" :parentMsg="selectRolesId" v-on:checkedTree="checkedTree"></OrgTreeCheck>
              </div>
              <div style="border-right: 1px solid #d9d9d9;margin: 0 20px"></div>
              <div style="width: calc(50% - 20px);height: 100%">
                <div style="display: flex;justify-content: space-between;align-items: center;padding-bottom: 10px;">
                  <div >已选权限</div>
                  <div @click="open1" style="margin-right: 10px;cursor: pointer;color: #409EFF">重新选择</div>
                </div>
                <OrgTreeCheck :key="jurisdictionRight" :filter="true" :parentMsg="selectRolesId" v-on:checkedTree="checkedTree"></OrgTreeCheck>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogUnitVisible = false">关 闭</el-button>
            </div>
          </el-dialog>
        </div>
      </template>
    </split-pane>


  </div>
</template>

<script>
import RolesTree from '../components/RolesTree'
import OrgTree from '../components/OrgTree'
import OrgTreeCheck from '../components/OrgTreeCheck'
import ResourcesTree from '../components/ResourcesTree'
export default {
  name: 'rolesManage',
  components: {
    RolesTree,
    OrgTree,
    OrgTreeCheck,
    ResourcesTree,
  },
  data () {
    var checkNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('排序号不能为空且大于0'))
      }else if((value+"").length>10){
        return callback(new Error('排序号长度不能超过10！'))
      }
      setTimeout(() => {
        if (!Number.isInteger(parseInt(value))) {
          callback(new Error('排序号为数值'))
        } else {
          callback()
        }
      }, 100)
    }
    var checkKey=(rule, value, callback) => {
      if(value && (value+"").length>10){
        return callback(new Error('编码长度不能超过10！'))
      }
      if(value && !/^[\d\w]+$/.test(value)){
        return callback(new Error('编码只能输入数字或字母！'))
      }
      callback();
    }
    return {
      filterMethod(query, item) {
        console.log(query,item);
        return item.name?item.name.indexOf(query) > -1:item.USER_NAME.indexOf(query) > -1;
      },
      rightTreeShow:true,
      resourceKeys:true,
      rolesTreeMsg: {},
      orgTreeMsg: {
        enumTitle: '组织管理',
        refreshTreeFlag: false
      },
      resourceTreeMsg: {},
      total: 0,
      rows: 15,
      currentPage: 1,
      selectPersonData: [],
      selectedPersonData: [],
      roleDia_loading: false,
      selectRolesId: '',
      filterName: '',
      treeInfo: [],
      tableData: [],
      dialogFormVisible: false,
      dialogPersonVisible: false,
      checkedUnitData: [],
      dialogUnitVisible: false,
      dialogResourceVisible: false,
      rolesForm: {
        roleId: '',
        roleName: '',
        parentId: '',
        switch: false,
        key: '',
        orderNo: 1
      },
      formLabelWidth: '120px',
      chooseTreeNode: {},
      rules: {
        roleName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符之间', trigger: 'blur' }
        ],
        orderNo: [
          { validator: checkNum, trigger: 'blur' }
        ],
        key:[
          { validator: checkKey, trigger: 'blur' }
        ]
      },
      title:'添加角色',
      disResourceIndex:'',
      disResourceRow:'',
      resourcesRight:'',
      resourcesLeft:'',
      jurisdictionRight:'',
      jurisdictionLeft:'',
    }
  },
  mounted: function () {
    this.rolesTreeMsg = {
      title: '角色管理',
      refreshTreeFlag: false,
      self: 1,
      async: 0,
      showCheckBox: false,
      onlyLeaf: false
    }
    this.getList()
  },
  methods: {
    inputSearch() {
      this.handleCurrentChange(1)
    },
    handleSizeChange (val) {
      this.rows = val
      this.currentPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    getTreeInfo: function (data) {
      this.treeInfo = data
      this.rows = 15
      this.currentPage = 1
      this.getList()
    },
    getPageMsg: function(data){
      this.pageMsg.currentPage = data
      this.getList()
    },
    getisDefault: function(data){
      if(data == 1){
        return '是'
      }else {
        return '否'
      }
    },
    getList: function () {
      this.$axios.get(
        this.$idmConfig.roles.rolesListUrl + '?t=' + new Date().getTime(),
        {
          params: {
            roleId: this.treeInfo.listenParentId,
            name: this.filterName,
            page: this.currentPage,
            rows: this.rows
          }
        }
      ).then(data => {
        if (data.data != null && data.data.rows != null) {
          this.tableData = data.data.rows
          this.total = data.data.total
        } else {
          this.$message({
            message: data.status,
            showClose: true,
            type: 'error'
          })
        }
      });
    },
    formAdd () {
      this.title='添加角色';
      if (this.$refs.rolesForm) {
        this.$refs.rolesForm.clearValidate()
        this.rolesForm = {
          roleId: '',
          roleName: '',
          parentId: '',
          key: '',
          switch: false,
          orderNo: ''
        }
      }
      this.dialogFormVisible = true
    },
    formSave (rolesForm) { // 保存节点
      this.$refs[rolesForm].validate((valid) => {
        if (valid) {
          this.rolesForm.parentId = this.treeInfo.listenParentId
          var a = this.rolesForm
          if (this.rolesForm.switch){
            this.rolesForm.isDefault = 1
          }else {
            this.rolesForm.isDefault = 0
          }
          var url = this.$idmConfig.roles.addUrl
          if(this.rolesForm.roleId !=null && this.rolesForm.roleId !=''){
            url = this.$idmConfig.roles.editUrl
          }
          this.$axios.post(
            url,
            this.$qs.stringify(this.rolesForm)
          ).then(data => {
            if (data.data.succeed) {
              this.$message.success("保存成功")
              this.dialogFormVisible = false
              this.getList()
              if(this.rolesForm.roleId !=null && this.rolesForm.roleId !=''){
                this.rolesTreeMsg = {
                  title: '角色管理',
                  refreshTreeFlag: true,
                  self: 1,
                  async: 0,
                  showCheckBox: false,
                  onlyLeaf: false
                }
              }else{
                this.rolesTreeMsg = {
                  title: '角色管理',
                  refreshTreeFlag: true,
                  self: 1,
                  async: 0,
                  showCheckBox: false,
                  onlyLeaf: false
                }
              }
            } else {
              this.$message({
                message: data.data.msg,
                showClose: true,
                type: 'error'
              })
            }
          })
        } else {
          console.log("验证失败!");
          return false
        }
      })
    },
    formEdit (index, row) {
      this.title = '编辑角色'
      if (this.$refs.rolesForm) {
        this.$refs.rolesForm.clearValidate()
      }
      if (row.isDefault){
        row.switch = true
      }else {
        row.switch = false
      }
      this.rolesForm = {
        roleId: row.roleId,
        roleName: row.roleName,
        parentId: row.parentId,
        switch: row.switch,
        orderNo: row.orderNo,
        key: row.key
      },
      this.dialogFormVisible = true
    },
    formDelete (index, row) {
      this.$confirm('永久删除该角色及子孙角色, 是否继续?', '提示', {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(
          this.$idmConfig.roles.deleteUrl,
          this.$qs.stringify({roleId: row.roleId})
        ).then(data => {
          if (data.data.succeed) {
            this.$message.success("删除成功")
            this.getList()
            this.rolesTreeMsg = {
              title: '角色管理',
              refreshTreeFlag: true,
              self: 1,
              async: 0,
              showCheckBox: false,
              onlyLeaf: false
            }
          } else {
            this.$message({
              message: data.data.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          showClose: true,
          message: '已取消删除'
        })
      })
    },
    // 单位数据权限分配
    disUnit: function (index, row) {
      this.selectRolesId = row.roleId
      this.dialogUnitVisible = true;
      // this.getOrgTreeInfo({ 'listenParentId': '-1'})
    },
    // 单位数据权限分配保存
    saveUnitData(){
      let orgIds=[];
      if(this.checkedUnitData &&  this.checkedUnitData.length>0){
        this.checkedUnitData.some((val)=>{
          orgIds.push(val.id);
        })
      }
      var urlStr = this.$idmConfig.roles.rolesToUnitUrl
      this.$axios({
        method: "POST",
        url:urlStr,
        data:this.$qs.stringify({
          roleId: this.selectRolesId,
          orgIds: orgIds.join(","),
        }),
        // headers: {
        //     'Content-Type': 'application/json'
        // }
      }).then(data => {
        if (data.data.succeed) {
          this.$message({
            message: "保存成功！",
            showClose: true,
            type: 'success'
          })
          // this.dialogUnitVisible=false;
          this.$refs.templateTree.getTemplateTree('refresh')
        } else {
          this.$message({
            message: data.data.msg,
            showClose: true,
            type: 'error'
          })
        }
      })
    },
    open1() {
      this.$confirm('此操作将清空已选权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.checkedTree([])
        this.$message({
          type: 'success',
          message: '清空成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清空'
        });
      });
    },
    checkedTree(data,filter){
      if (!!filter) {
        this.jurisdictionLeft = new Date().getTime()
      } else  {
        this.jurisdictionRight = new Date().getTime()
      }
      this.checkedUnitData = data;
      this.saveUnitData()
    },
    // 分配角色
    disPerson: function (index, row) {
      this.selectRolesId = row.roleId
      this.orgTreeMsg = {
        enumTitle: '组织管理',
        refreshTreeFlag: false
      }
      this.selectPersonData = []
      this.selectedPersonData = []
      this.dialogPersonVisible = true
      this.getOrgTreeInfo({ 'listenParentId': '-1'})
    },
    getOrgTreeInfo: function(data){
      var pid = ''
      if(data.listenParentId != '-1'){
        pid = data.listenParentId
      }
      this.roleDia_loading=true;
      this.$axios.get(
        this.$idmConfig.person.getPersonListUrl + '?t=' + new Date().getTime(),
        {
          params:{
            orgId: pid
          }
        }
      ).then(result => {
        if (result.status == 200) { // 待选人员
          for (var i=0; i<result.data.length; i++){
            result.data[i].lable = result.data[i].name +'('+result.data[i].userName+')'
          }

          this.$axios.post( // 已选人员
            this.$idmConfig.roles.rolesAlreadyToPersonUrl,
            this.$qs.stringify({
              roleId: this.selectRolesId,
              orgId: data.listenParentId
            })
          ).then(res => {
            this.roleDia_loading=false;
            if (res.data.succeed) {
              this.selectedPersonData = [] // 已选人员
              for (var i=0; i<res.data.data.length; i++){
                this.selectedPersonData.push(''+res.data.data[i].USER_ID)
              }
              var aa =this.selectedPersonData
              this.selectPersonData = result.data // 待选人员（赋值顺序考虑加载延迟效果）
            } else {
              this.$message({
                message: res.data.msg,
                showClose: true,
                type: 'error'
              })
            }
          }).catch((e)=>{this.roleDia_loading=false;})

        } else {
          this.roleDia_loading=false;
          this.$message({
            message: result.statusText,
            showClose: true,
            type: 'error'
          })
        }
      }).catch((e)=>{this.roleDia_loading=false;})
    },
    choosePerson: function(value, direction, movedKeys){
      var urlStr = this.$idmConfig.roles.rolesToPersonUrl
      if(direction === "left") {
        urlStr = this.$idmConfig.roles.rolesRemovePersonUrl
      }
      this.$axios.post(
        urlStr,
        this.$qs.stringify({
          roleId: this.selectRolesId,
          jsonUserId: JSON.stringify(movedKeys)
        })
      ).then(data => {
        if (data.data.succeed) {
        } else {
          this.$message({
            message: data.data.msg,
            showClose: true,
            type: 'error'
          })
        }
      })
    },
    // 添加资源
    disResource: function (index, row) {
      this.disResourceIndex = index,
      this.disResourceRow = row,
      this.selectRolesId = row.roleId
      this.$axios.post(
        this.$idmConfig.roles.rolesAlreadyToResourcesUrl,
        this.$qs.stringify({
          roleId: this.selectRolesId
        })
      ).then(result => {
        if(result.data.succeed){
          console.log(result.data);
          var selectedArr = []
          for(var i=0; i<result.data.data.length; i++){
            //只添加子节点数据,防止选中父节点后，全选子节点
            // if(result.data.data[i].IS_CHILD){
            selectedArr.push(result.data.data[i].RESOURCE_ID)
            // }
          }
          console.log(selectedArr);
          this.resourceTreeMsg = {
            title: '资源管理',
            refreshTreeFlag: false,
            self: 1,
            async: 0,
            showCheckBox: true,
            onlyLeaf: false,
            defaultCheckedKeys: selectedArr
          }
          this.dialogResourceVisible = true
        }else {
          this.$message({
            message: result.data.msg,
            showClose: true,
            type: 'error'
          })
        }
      })
    },
    opens(){
      this.$axios.post(
        this.$idmConfig.roles.rolesToResourcesUrl,
        this.$qs.stringify({
          roleId: this.selectRolesId,
          jsonResourceId: JSON.stringify([])
        })
      ).then(data => {})
     this.dialogResourceVisible=false
    },
    open() {
      this.$confirm('此操作将清空已选资源, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getResourceKeys([])
        this.$message({
          type: 'success',
          message: '清空成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清空'
        });
      });
    },
    getResourceKeys: function (data,filter) { // 为该角色已分配资源
      if (!!filter) {
        this.resourcesLeft = new Date().getTime()
      } else  {
        this.resourcesRight = new Date().getTime()
      }
      console.log(data);
      // this.rightTreeShow = false
      this.$axios.post(
        this.$idmConfig.roles.rolesToResourcesUrl,
        this.$qs.stringify({
          roleId: this.selectRolesId,
          jsonResourceId: JSON.stringify(data)
        })
      ).then(data => {
        if (data.data.succeed) {
          var a= ''
          this.disResource(this.disResourceIndex,this.disResourceRow)
        } else {
          this.$message({
            message: data.data.msg,
            showClose: true,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.el-button--primary{
  background-color:#4873C0 !important;
  border-color:#4873C0 !important;
  color: white !important;
}
  /deep/ .splitter-pane-resizer.vertical[data-v-212fa2a4]{
    background-color: #e6eef8;
    width: 1px;
    margin-left: 5px;
    border-left: none;
    border-right: none;
  }
  /deep/ .splitter-pane-resizer[data-v-212fa2a4]{
    opacity: initial;
  }
#main{
  height: 100%;
}
#treeDivs{
  width: 99%;
  height: 100%;
  float: left;
  background: white;
  margin-right: 5px;
  overflow: auto;
}
#listTables{
  width: 100%;
  float: right;
  background: white;
  height: 100%;
  padding: 0 10px 10px 10px;
  box-sizing: border-box;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.rightTopButton {
  text-align: left;
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.rightContent {
  height: calc(100% - 32px - 52px);
  background: white;
  overflow: auto;
  box-sizing: border-box;
}
.pagination {
  height: 32px;
  margin: 0px 0 -32px;
  background: #ECF5FF;
  text-align: left;
}
</style>
<style lang="less" scope>
.roleDlg .el-dialog__body{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  .el-transfer{
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .el-transfer__buttons{
      display: flex;
      flex-flow: column;
      width: 100%;
      justify-content: center;
      align-items: center;
      padding: 0;
      flex: auto;
      .el-button+.el-button{
        margin: 0;
      }
    }
    .el-transfer-panel{
      width: 40%;
      min-width: 280px;
      min-height: 380px;
      .el-transfer-panel__body{
        height: 340px;
        .el-transfer-panel__list{
          height: 80% !important;
          .el-transfer-panel__item{
            min-width: 240px;
            margin-right: auto;
          }
        }
      }
    }
  }
}
  #resourceDialog .el-tree{
    max-height: 270px;
    overflow-y: auto;
  }

  .rDialogDiv .el-dialog__body {
    padding: 0px 20px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/roles.vue